import { useEffect, useState } from 'react';
import { api, apiBlob } from '../api';

/**
 * Bild, das über einen authentifizierten Endpunkt geladen wird. Ein normales
 * <img src> kann den JWT nicht mitschicken, deshalb holen wir die Bytes per
 * fetch mit Authorization-Header und rendern sie als Object-URL.
 */
export function AuthBild({
  src,
  alt,
  style,
  onClick,
}: {
  src: string;
  alt?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let aktiv = true;
    let objURL: string | null = null;
    (async () => {
      try {
        objURL = URL.createObjectURL(await apiBlob(src));
        if (aktiv) setUrl(objURL);
        else URL.revokeObjectURL(objURL);
      } catch {
        /* Platzhalter bleibt */
      }
    })();
    return () => {
      aktiv = false;
      if (objURL) URL.revokeObjectURL(objURL);
    };
  }, [src]);

  if (!url) {
    return <div style={{ background: '#eef1f4', borderRadius: 8, ...style }} aria-label={alt} />;
  }
  return (
    <img
      src={url}
      alt={alt}
      onClick={onClick}
      style={{ objectFit: 'cover', borderRadius: 8, cursor: onClick ? 'zoom-in' : 'default', ...style }}
    />
  );
}

interface FotoZeile {
  id: string;
}

/**
 * Zeigt alle Fotos zu einem Bezug (Wareneingang oder Container) als Vorschau,
 * Klick öffnet eine Großansicht. Ohne Fotos wird nichts gerendert.
 */
export function FotoGalerie({
  refType,
  refId,
  reload,
}: {
  refType: 'wareneingang' | 'container';
  refId: string;
  reload?: number;
}) {
  const [fotos, setFotos] = useState<FotoZeile[]>([]);
  const [gross, setGross] = useState<string | null>(null);

  useEffect(() => {
    let aktiv = true;
    api<FotoZeile[]>('/api/fotos', { query: { refType, refId } })
      .then((f) => aktiv && setFotos(f))
      .catch(() => {});
    return () => {
      aktiv = false;
    };
  }, [refType, refId, reload]);

  if (fotos.length === 0) return null;

  return (
    <>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {fotos.map((f) => (
          <AuthBild
            key={f.id}
            src={`/api/fotos/${f.id}/inhalt`}
            alt="Foto"
            style={{ width: 84, height: 84 }}
            onClick={() => setGross(f.id)}
          />
        ))}
      </div>
      {gross && (
        <div
          onClick={() => setGross(null)}
          style={{
            position: 'fixed',
            inset: 0,
            background: '#000c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: 24,
          }}
        >
          <AuthBild src={`/api/fotos/${gross}/inhalt`} alt="Foto" style={{ maxWidth: '90%', maxHeight: '90%' }} />
        </div>
      )}
    </>
  );
}
